import { render, staticRenderFns } from "./list-categories.vue?vue&type=template&id=c5f7f3cc&"
import script from "./list-categories.vue?vue&type=script&lang=js&"
export * from "./list-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports